import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import { MenuItem } from "./types";
import defaultProfile, { asyncRoute } from "./default";
import { i18n } from "../i18n";
import { faCartShopping } from "@fortawesome/pro-solid-svg-icons";
import { commonMenuItems } from "@/game_profiles/common";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";

const { t } = i18n.global;
const configSections: ConfigSection[] = [
  { component: "FivemLicense" },
  { component: "ConfSection", props: { name: "artifact_build" } },
  { component: "FivemBasicSection", props: { name: "basic" } },
];

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items[0] = new MenuItem(
    "",
    faChartLine,
    asyncRoute(() => import("../components/views/status/fivem/FivemStatus.vue")),
  );
  menu[0].items.push(commonMenuItems.console);
  menu[1].items.push(
    new MenuItem(
      "tebex",
      faCartShopping,
      asyncRoute(() => import("../components/views/Tebex.vue")),
    ),
  );
  return menu;
};

const join = () => {
  window.open(t("ngp/settings/section/fivem_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/fivem_wiki",
    joinFn: join,
  },
});
